import { render, staticRenderFns } from "./PhotoViewerButton.vue?vue&type=template&id=f5b2de0a&scoped=true&"
import script from "./PhotoViewerButton.vue?vue&type=script&lang=js&"
export * from "./PhotoViewerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b2de0a",
  null
  
)

export default component.exports